import React from "react";
import { Button, Form, Icon, InputNumber } from "antd";
import AssetModal from "../AssetModal";

/**
 * SubAssetModal
 *
 * Renders the "Sub Assets" section for a single parent asset row of the
 * Purchase Invoice (Asset type) form. A sub asset is a full Asset in its own
 * right: it is created with the SAME asset form as the parent (via AssetModal ->
 * AssetCreate, capturing sub type / model / alt name / etc.) and additionally a
 * Rate. Its location and sub-location are inherited from the parent asset row, so
 * those fields are intentionally not shown here (AssetModal already strips them).
 *
 * Each sub asset is stored as { assetData, rate }. The whole list is lifted to the
 * parent form via onChange(parentIndex, subAssets) so the backend can create each
 * sub asset plus its Stock -> Asset Sub Asset Transfer.
 */
class SubAssetModal extends React.Component {
  keyCounter = 0;

  addSlot = () => {
    const { index, value = [], onChange } = this.props;
    onChange(index, [...value, { _key: `sub-${this.keyCounter++}`, assetData: null, rate: undefined }]);
  };

  removeSlot = (slotIndex) => {
    const { index, value = [], onChange } = this.props;
    const next = [...value];
    next.splice(slotIndex, 1);
    onChange(index, next);
  };

  setSlotAsset = (slotIndex, assetData) => {
    const { index, value = [], onChange } = this.props;
    const next = [...value];
    if (!next[slotIndex]) {
      return;
    }
    next[slotIndex] = { ...next[slotIndex], assetData: assetData || null };
    onChange(index, next);
  };

  setSlotRate = (slotIndex, rate) => {
    const { index, value = [], onChange } = this.props;
    const next = [...value];
    if (!next[slotIndex]) {
      return;
    }
    next[slotIndex] = { ...next[slotIndex], rate };
    onChange(index, next);
  };

  noop = () => {};

  render() {
    const { index, value = [], item, form, title, history, match, owner, useAssetModelInlineCreate, disabled } = this.props;
    const style = {
      marginTop: '10px',
      border: '1px dashed #52c41a',
      padding: '20px',
      borderRadius: '9px',
    };

    return (
      <div>
        {value.map((slot, slotIndex) => (
          <div key={slot._key || slotIndex} style={style}>
            <AssetModal
              history={history}
              index={index}
              getLinkedAssetData={this.noop}
              title={title}
              match={match}
              key={'subAssets'}
              item={item}
              useAssetModelInlineCreate={useAssetModelInlineCreate}
              removeStateAsset={() => this.removeSlot(slotIndex)}
              form={form}
              owner={owner}
              saveOwner={this.noop}
              data={(slot.assetData && [slot.assetData]) || []}
              getAssetData={(list) => this.setSlotAsset(slotIndex, list && list[0])}
            />

            <Form.Item label={'Rate'} style={{ marginTop: '10px' }}>
              <InputNumber
                value={slot.rate}
                min={0}
                disabled={disabled}
                onChange={(rate) => this.setSlotRate(slotIndex, rate)}
                onWheel={(event) => event.currentTarget.blur()}
                placeholder={'Rate'}
                style={{ marginRight: 8 }}
              />
            </Form.Item>

            {
              !disabled && <Icon
                className="dynamic-delete-button"
                type="minus-circle-o"
                onClick={() => this.removeSlot(slotIndex)}
              />
            }
          </div>
        ))}

        {
          !disabled && <Button
            type="dashed"
            onClick={this.addSlot}
            style={{ width: '60%', marginTop: '15px' }}
          >
            <Icon type="plus" /> Add Sub Asset
          </Button>
        }
      </div>
    );
  }
}

export default SubAssetModal;
